import { useEffect } from "react";
import { useFormContext } from "react-hook-form";

const ScoreValue = ({ score }: { score: number }) => {
  const { setValue } = useFormContext();

  useEffect(() => {
    setValue("score", score);
  }, [score]);

  return null;
};

export default ScoreValue;
